import { render, staticRenderFns } from "./RollingStockForm.vue?vue&type=template&id=01b72db6&scoped=true"
import script from "./RollingStockForm.vue?vue&type=script&lang=js"
export * from "./RollingStockForm.vue?vue&type=script&lang=js"
import style0 from "./RollingStockForm.vue?vue&type=style&index=0&id=01b72db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b72db6",
  null
  
)

export default component.exports